import React from "react";
import { Modal } from "components";
import { IoMdClose } from "react-icons/io";
import TermsAndConditions from "./TermsAndConditions";

const TandCModal = ({ showModal, onClose }) => {
  return (
    <Modal showModal={showModal} onClose={onClose} size="lg">
      <div className="my-4">
        <div className="d-flex justify-content-end">
          <IoMdClose className="cursor-pointer" onClick={onClose} />
        </div>
        <TermsAndConditions handleModalClose={onClose} />
      </div>
    </Modal>
  );
};

export default TandCModal;
